////////////////////////////////////////////////////////////////////////////////////////////////////////////
//Note: This view model is used by the views of both GradesController#show & CourseworkEntriesController#new
//So please test coursework submission and coursework grade review when making a change here.
////////////////////////////////////////////////////////////////////////////////////////////////////////////
import Fields from './fields';

export default function (data) {
  var self = this;


  self.$el = $('#coursework_entry_form');
  self.coursework = ko.observable();
  self.preview = ko.observable(JSON.parse($('#preview').val() || 'false'));
  self.chartRingSets = [];
  self.coursework_entry = null;
  self.showQuestionList = ko.observable(false);

  this.onFinalQuestion = () => this.current_question_index() + 1 === this.total_questions
  this.onFirstQuestion = () => !this.current_question_index()

  self.showQuestionList.subscribe(function() {
    self.recalcCompletedQuestionsCount();

    //
    //TODO: Relying on timeouts is an anti-pattern, trigger from DOM
    //
    setTimeout(function(){
      self.handleChartResize();
      $('#quiz_nav').slick('setPosition');
      Kadenze.WebApp.initKadenzeTooltips();
      Kadenze.UIUtil.initExpandableText();
    }, 100);

    self.updateNavPosition(self.current_question_index());
  });

  self.hideCompletedCheckboxLabel = ko.observable('Show Only Unanswered Questions');

  self.completed_questions = ko.observable(0);

  self.completed_questions.subscribe(function(){
    var label = 'Show Only Unanswered Questions (' +
                (self.total_submittable_questions - self.completed_questions()) +
                ' total)';

    self.hideCompletedCheckboxLabel(label);
  });

  self.current_question_index = ko.observable();
  self.current_question_index.subscribe(function(index) {

    //Update selectpicker pos for mobile
    $('select.selectpicker')[0].selectedIndex = index;

    var item = self.coursework.coursework_fields()[index];
    self.selectQuestion(item);

    //Hack to fix chart ring resizing issue
    if(self.coursework.graded() && self.coursework.coursework_fields().length == (index + 1)) {
      self.handleChartResize();
    }

    $.each( $('.kdnze-svg-icon'), function(i,val){
      Kadenze.SvgIcon.init( this );
    });

    //Update the left nav position
    self.updateNavPosition(index);
  });

  // hide completed questions from question nav and list
  self.hideCompleted = ko.observable(false);

  self.hideCompletedFilter = function(){ return $(this).find('.completed').length == 0; };

  self.hideCompleted.subscribe(function() {
    if(self.hideCompleted()){
      $('#quiz_nav').slick('slickFilter', self.hideCompletedFilter);
    } else {
      $('#quiz_nav').slick('slickUnfilter');
    }
  });

  // hide correct answers from question nav and list
  self.hideCorrect = ko.observable(false);

  self.hideCorrectFilter = function(){ return $(this).find('.correct').length == 0; };

  self.hideCorrect.subscribe(function() {
    if(self.hideCorrect()){
      $('#quiz_nav').slick('slickFilter', self.hideCorrectFilter);
    } else {
      $('#quiz_nav').slick('slickUnfilter');
    }
  });

  // set the text label for the 'show onwly incorrect answers' checkbox in the quiz nav
  self.hideCorrectCheckboxLabel = function(){
    var label = 'Show Only Incorrect Answers (' + self.countAnswerTypes('incorrect') + ' total)';
    return label;
  };

  // update the nav slider to show the current question
  self.updateNavPosition = function (index) {
    var filterAction;
    var $quizNav = $('#quiz_nav');

    if ($quizNav.hasClass('slick-initialized')) {
      if (self.hideCompleted() || self.hideCorrect()) {
        filterAction = self.hideCompleted() ? self.hideCompletedFilter : self.hideCorrectFilter;

        var $unFilteredSlides = $quizNav.slick('slickUnfilter').slick('getSlick').$slides;
        var $filteredSlides = $quizNav.slick('slickFilter', filterAction).slick('getSlick').$slides;
        var $slide = $($unFilteredSlides[index]);
        var filteredIndex = $filteredSlides.index($slide);

        if (filteredIndex >= 0)
          $quizNav.slick('slickGoTo', filteredIndex);
      } else {
        $quizNav.slick('slickGoTo', index);
      }
    }
  };

  self.getTemplate = function(type) {
    var templateName = Kadenze.Util.snakeCase(type);
    var questionTemplate = JST['templates/dynamic_fields/submission/' + templateName]();
    return Kadenze.I18n.tt(questionTemplate, 'en');
  };

  self.templates = {};
  $.each([
    'FillInTheBlankField',
    'WrittenResponseField',
    'MultipleChoiceField',
    'TrueFalseField',
    'RatingField',
    'MatrixField',
    'AnswerBuilderField',
    'TimelineField',
    'InteractiveTimelineField',
    'ImageMatchingField',
    'SectionBreakField',
    'MetaField',
    'SubmittedField',
    'GradedField',
    'SummaryField',
    'Attachments',
    'Feedback'
  ], function(index, name) {
    self.templates[name] = self.getTemplate(name);
  });

  self.initUI = function() {
    self.user_preferences = JSON.parse($('#user_preferences_json').val() || '{}');

    $('.rateit').bind('reset', function() {
      var el = $(this).parent()[0];
      var vm = ko.dataFor(el);
      vm.question_answer(undefined);
    });

    self.buildChartRings();
    self.buildReviewScoreRingChart();

    $(window).on('resize', self.handleChartResize).trigger('resize');

    if(self.coursework.graded()) {
      self.current_question_index(self.coursework.coursework_fields().length-1);
      self.showQuestionList(true);
    } else {
      self.current_question_index(0);
    }

    //TODO: Move this to knockout
    $('#quiz_page').on('keypress', function(event) {
      if(isNaN(Number(this.value))){
        this.value = '';
      }
      var keycode = (event.keyCode ? event.keyCode : event.which);
      var questionNumber = this.value;
      if(keycode == '13') {
        $('#quiz_page').blur();
        self.virtualQuestionIndex(questionNumber);
      }
    }).focus(function() {
      this.value = '';
    });

    $('.tab-subnav__tab').find('a:first').tab('show');

    Kadenze.WebApp.initKadenzeTooltips();
    Kadenze.UIUtil.initExpandableText();
    Kadenze.Carousel.init($('.js-carousel')[0]);
  };

  self.buildReviewScoreRingChart = function() { // for graded quiz view overview page
    $('.js-chart-percent-ring').hide();
    var $svgHolder = $('.question-list__score-feedback > .svg-holder--grade-percent').html('').removeClass('hidden');
    var $rings = $('.question-list__score-feedback .circle-percent');
    var percRing = new Kadenze.Chart.PercentageRings($svgHolder[0], $rings, false, 1);

    self.chartRingSets.push(percRing);
  };

  self.buildChartRings = function() {
    var $ringCharts = $('.js-chart-percent-rings');

    $ringCharts.each( function(){
      $(this).hide();

      var $svgHolder = $(this).closest('div.in-section').find('.svg-holder--grade-percent').html('').removeClass('hidden');
      var $rings = $(this).find('.circle-percent');
      var percRing = new Kadenze.Chart.PercentageRings($svgHolder[0], $rings, false, 2);

      self.chartRingSets.push(percRing);
    });
  };

  self.handleChartResize = function() {
    for(var i=-1; ++i<self.chartRingSets.length;){
      self.chartRingSets[i].resize();
    }
  };

  self.virtualQuestionIndex = ko.computed({
    read: function() {
      var number = 1;

      self.current_question_index(); //For ko to always trigger this computed

      if (!_.isEmpty(self.coursework.coursework_fields)) {
        var current_question = self.coursework.coursework_fields()[self.current_question_index()];
        number = _.isFunction(current_question.number) ? current_question.number() : undefined;
      }

      return number;
    },

    write: function(value) {
      var index = _.findIndex(
        self.coursework.coursework_fields(),
        function(field) { return field.number() == parseInt(value); }
      );

      self.current_question_index(index);
      self.showQuestionList(false);
    }
  });

  // get the number of correct, incorrect, and partially correct answers
  self.countAnswerTypes = function(type) {
    var answerTypes = _.countBy(self.coursework.coursework_fields(), function(field) {
      if (field.isGraded() && !field.isSectionBreak() && !field.isMeta()) {
        if (field.isCorrect()) {
          return 'correct';
        } else if (field.isPartiallyCorrect()) {
          return 'partially_correct';
        } else if (!field.isCorrect()) {
          return 'incorrect';
        }
      }
    });

    var count = (typeof answerTypes[type] !== 'undefined') ? answerTypes[type] : 0;

    return count;
  };

  self.getQuestionNumber = function(item, index) {
    var num;

    if (item.isMeta()) {
      num = self.coursework.presentation_name();

      if(self.coursework.submitted()) {
        num = num + ' ' + Kadenze.I18n.t('coursework_entries.new.results');
      } else {
        num = num + ' ' + Kadenze.I18n.t('coursework_entries.new.summary');
      }
    } else {
      num = Kadenze.I18n.t('coursework_entries.new.question') + item.number();
    }

    if (item.isSectionBreak())
      num = '';

    return num;
  };

  self.getQuestionPoints = function(item) {
    var points = '';

    if (item.grading_criteria && typeof item.grading_criteria != 'function' && self.coursework.type() != 'Survey') {
      points = ' (';

      if (item.grading_criteria.extra_credit())
        points += 'Extra Credit, ';

      if (self.coursework.graded() && item.grade_entry) {
        points += item.grade_entry.value().toFixed(2).replace(/[.,]00$/, '') || 0;
        points += '/';
      }

      points += item.grading_criteria.points();
      points += item.grading_criteria.points() > 1 ? ' pts' : ' pt';
      points += ')';
    }

    return points;
  };

  self.getQuestionType = function(item) {
    var type = item.question_type() + self.getQuestionPoints(item);

    if (item.isMeta()) {
      if(self.coursework.submitted() && !self.coursework.graded()) {
        type = Kadenze.I18n.t('coursework_entries.new.score_available_shortly');
      } else if(self.coursework.submitted() && self.coursework.graded()) {
        type = 'Score: ' + self.coursework.score.extend({ numberToPercentage: 2 })();
      } else {
        type = Kadenze.I18n.t('coursework_entries.new.questions_answered');
      }
    }

    return type;
  };

  self.getQuestionStatus = function(item) {
    var status = item.question_status();

    if (item.isMeta()) {
      if(self.coursework.submitted() && !self.coursework.graded()) {
        status = Kadenze.I18n.t('coursework_entries.new.results');
      } else {
        status = Kadenze.I18n.t('coursework_entries.new.summary');
      }
    } else if (item.isSectionBreak()) {
      status = 'Section Break';
    }

    return status;
  };

  self.getQuestion = function(item, index) {
    var field = item.getFDObj(item);
    var question;

    if (item.isMeta()) {
      if(self.coursework.submitted() && !self.coursework.graded()) {
        question = Kadenze.I18n.t('coursework_entries.new.grade_pending');
      } else if(self.coursework.submitted() && self.coursework.graded()) {
        question = Kadenze.I18n.t('coursework_entries.new.grade_ready');
      } else {
        question = self.completed_questions() +
                   I18n.t('coursework_entries.new.out_of') +
                   self.total_submittable_questions;
      }
    } else {
      question = field.question ? field.question() : '';

      if (index) { //Long form w/ index
        question = item.number() + ') ' + question;
      } else { //Short form
        question = s.stripTags(question).trimToLength(65);
      }
    }

    return question;
  };

  self.getSectionBreakDesc = function(item) {
    var fullDescription = item.getFDObj(item).message();
    return s.stripTags(fullDescription).trimToLength(65);
  };

  self.getGradingPolicyDesc = function(item) {
    var fdObj = item.getFDObj(item);
    var description = null;

    if (fdObj.grading_format)
      description = I18n.t('coursework_entries.new.gf_' + fdObj.grading_format());

    return description;
  };

  self.recalcCompletedQuestionsCount = function() {
    var completed = _.reduce(
      self.coursework.coursework_fields(),
      function(num, field) { return field.isCompleted() ? 1 + num : num; },
      0
    );

    self.completed_questions(completed);
  };

  self.selectQuestion = function(item) {
    var completed = 0;

    $.each(self.coursework.coursework_fields(), function(index, field) {
      if(field.id() === item.id()) {
        field.isCurrent(true);
      } else {
        field.isCurrent(false);
      }

      if (field.isCompleted())
        completed++;
    });

    self.completed_questions(completed);
  };

  self.canProceed = function() {
    var proceed = true;
    var question = self.coursework.coursework_fields()[self.current_question_index()];

    if (!question.isCompleted()) {
      if (question.isRequired()) {
        proceed = false;

        Kadenze.Notice.error({
          title: 'Required Question',
          message: 'Please complete the current question before proceeding.'
        });

      } else if (question.isRequiredConfirmation()) {
        proceed = false;

        var question_specific_msg = I18n.t(
          'coursework_entries.new.incomplete_' +
          Kadenze.Util.snakeCase(question._type())
        );

        var msg = question_specific_msg ?
          question_specific_msg :
          'You haven\'t completed this question. ';

        Kadenze.UIUtil.confirmAction(
          msg + 'Click Ok to continue to the next question or Cancel to stay and complete this question.',
          function() {
            question.isRequiredConfirmation(false);
            self.nextQuestion();
          },
          null,
          {
            cancel_btn_text: 'Cancel',
            ok_btn_text: 'Ok'
          }
        );
      }
    }

    return proceed;
  };

  self.nextQuestion = function() {
    if (self.canProceed()) {
      var newIndex = self.current_question_index() + 1;

      if (newIndex > (self.total_questions - 1))
        newIndex = 0;

      $('html, body').animate({scrollTop:0}, 'slow');

      self.current_question_index(newIndex);
    }
  };

  self.prevQuestion = function() {
    var newIndex = self.current_question_index() - 1;

    if (newIndex < 0)
      newIndex = (self.total_questions - 1);

    $('html, body').animate({scrollTop:0}, 'slow');

    self.current_question_index(newIndex);
  };

  self.jumpToQuestion = function(questionNumber) {
    if(questionNumber == 0)
      self.current_question_index(0);

    if(questionNumber <= self.total_questions)
      self.current_question_index(questionNumber-1);

    if(questionNumber > self.total_questions)
      self.current_question_index(self.total_questions-1);
  };

  self.getFieldEntry = function(fieldId) {
    _.findWhere(self.coursework_entry.coursework_field_entries, {coursework_field_id: fieldId});
  };

  self.submitEntry = function() {
    var required_incomplete = _.any(self.coursework.coursework_fields(), function(field) {
      return field.isRequired() && !field.isCompleted();
    });

    if (required_incomplete) {
      Kadenze.Notice.error({message: 'Please complete all the required questions before submitting.'});
      return;
    }

    var confirmPrompt = Kadenze.I18n.t('coursework_entries.new.confirm_prompt');

    if (self.completed_questions() != self.total_submittable_questions)
      confirmPrompt = I18n.t('coursework_entries.new.unanswered_questions') + ' ' + confirmPrompt;

    var url = Kadenze.Routes.course_coursework_coursework_entries_path(
      self.coursework.course_id(),
      self.coursework.id()
    );

    var method = 'POST';

    if (self.coursework.submitted() && self.coursework_entry.id) {
      url = Kadenze.Routes.course_coursework_coursework_entry_path(
        self.coursework.course_id(),
        self.coursework.id(),
        self.coursework_entry.id
      );

      method = 'PATCH';
    }

    $.each(self.coursework.coursework_fields(), function(index, field) {
      if (field._type() == 'MetaField')
        return;

      var value = _.isObject(field.question_answer()) ?
        ko.mapping.toJSON(field.question_answer()) :
        field.question_answer();

      self.coursework_entry.coursework_field_entries[index].value = value;
      self.coursework_entry.coursework_field_entries[index].variant = field.rand_fd_index();
    });

    var data = {coursework_entry: $.extend(true, {}, self.coursework_entry)};

    data.coursework_entry.coursework_field_entries_attributes = data.coursework_entry.coursework_field_entries;

    delete data.coursework_entry.coursework_field_entries;

    Kadenze.UIUtil.confirmAction(confirmPrompt, () => {
      Kadenze.UIUtil.makeRequest(url, method, data, self.$el,
        () => { }, //BeforeSave

        (data, textStatus, xhr) => { //Success
          self.coursework.submitted(true);

          if (self.coursework.first_adaptive_submission() && !self.user_preferences['hide_due_dates']) {
            Kadenze.UIUtil.showFirstSubmissionModal(self.user_preferences, self.$el);
            self.coursework.first_adaptive_submission(false);
          }

          if (self.coursework.resubmission())
            new Kadenze.Notice.success({ message: xhr.responseJSON.message });
        },

        xhr => { // Error
          const message = xhr.responseJSON ?
            xhr.responseJSON.message :
            xhr.statusText

          new Kadenze.Notice.error({ message });
        },

        () => { } //Complete
      );
    });
  };

  self.backToCoursework = function() {
    window.onbeforeunload = null;
    window.location = Kadenze.Routes.course_coursework_index_path(self.coursework.course_id());
  };

  self.injectMetaField = function(data) {
    data.coursework_fields.push({
      id: 0,
      _type: 'MetaField',
      field_definition: [{
        _type: 'MetaField',
        question: ''
      }]
    });
  };

  self.quizNavClickAction = function(data, index) {
    if(self.coursework.submitted() && data._type() == 'MetaField') {
      self.showQuestionList(true);
    } else {
      self.current_question_index(index);
      self.showQuestionList(false);
    }
  };

  this.bindData = data => {
    const mapping = {
      'coursework_fields': {
        'create': options => {
          const constructor = Fields[options.data._type] || Fields.BaseField
          return new constructor(options.data, options.parent)
        }
      }
    }

    this.injectMetaField(data.coursework)

    this.coursework = ko.mapping.fromJS(data.coursework, mapping)
    this.coursework_entry = data.coursework_entry

    this.total_questions = this.coursework.coursework_fields().length

    this.total_submittable_questions = this.coursework
      .coursework_fields()
      .filter(f => !f.isSectionBreak() && !f.isMeta())
      .length

    if (!this.coursework.graded())
      window.onbeforeunload = (e) => {
        e.preventDefault()
        e.returnValue = ''

        if (!this.coursework.submitted())
          return I18n.t('notice.nav_guard_warning')
      }
  }

  (() => this.bindData(data))()
}
